import React from "react";
import { TableColumnsType } from "antd";
import dayjs from "dayjs";
import s from "./RequestTable.module.scss";
import clsx from "clsx";
import { PaginatedUserAPI } from "../../../../../../../../../libs/Utils/Types/APIManagement";
import relativeTime from "dayjs/plugin/relativeTime";
import ReusableTable from "../../../../../../../../../global components/Table/Table";
import ReusablePopover from "../../../../../../../../../global components/Popover/ReuseablePopover";
import ActionPopOverDetails from "../ActionPopOverDetails";
import Elipses from "../../../../../../../../../global components/Icons/Elipses";

dayjs.extend(relativeTime);
type ColumnType = {
  key: string;
  request: string; // ISO date string

  keyPreview: string;
  lastActive: string;
  status: string;
};
type PropType = {
  data: PaginatedUserAPI["data"];
  loading: boolean;
  mutate: () => void;
};
function RequestTable({ data, loading, mutate }: PropType) {
  const columns: TableColumnsType<ColumnType> = [
    {
      title: "API Key",
      dataIndex: "keyPreview",
      key: "keyPreview",
      render: (keyPreview: string) => <span>{keyPreview}</span>,
    },
    {
      title: "Total Request",
      dataIndex: "request",
      key: "request",
      render: (request: string) => <span>{request}</span>,
    },
    {
      title: "Last Activity",
      dataIndex: "lastActive",
      key: "lastActive",
      render: (lastActive: string) => <span>{lastActive}</span>,
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => (
        <span
          className={clsx({
            [s.active]: status.toLowerCase().includes("active"),
            [s.inactive]: status.toLowerCase().includes("inactive"),
            [s.revoked]: status.toLowerCase().includes("revoked"),
          })}
        >
          {status}
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record: { key: string; keyPreview: string }) => (
        <ReusablePopover
          trigger={"hover"}
          content={
            <ActionPopOverDetails
              previewAPI={record.keyPreview}
              id={record.key}
              mutate={mutate}
            />
          }
        >
          <Elipses width={24} height={24} cursor={"pointer"} />
        </ReusablePopover>
      ),
    },
  ];
  const dataSource: ColumnType[] = data.map((item) => ({
    key: item.id,
    keyPreview: item.keyPreview,
    lastActive: dayjs(item.lastUsedAt).fromNow(),
    request: item.totalRequests.toLocaleString(),
    status: item.status,
  }));
  return (
    <ReusableTable
      columns={columns}
      dataSource={dataSource}
      loading={loading}
    />
  );
}

export default RequestTable;
